import type { TFunction } from 'i18next';

import type { CustomerTypeOption, QuestionTypeOption } from './BusinessUnitSolutionsWeb2CaseForm.schema';

export const getQuestionOptions = (
  t: TFunction<'translation', undefined>,
  customerType?: CustomerTypeOption['value']
): QuestionTypeOption[] => {
  const options: QuestionTypeOption[] = [
    {
      label: t('blocks:staticForms.chargingEventsLoadManagement'),
      value: 'Charging Events / Load Management',
    },
    {
      label: t('blocks:staticForms.billingSystem'),
      value: 'Billing system',
    },
    {
      label: t('blocks:staticForms.cpDashboard'),
      value: 'CP Dashboard',
    },
    {
      label: t('blocks:staticForms.rfids'),
      value: 'RFIDs',
    },
    {
      label: t('blocks:staticForms.hardwareDefectErrorMessage'),
      value: 'Hardware defect / Error message',
    },
    {
      label: t('blocks:staticForms.sometingElse'),
      value: 'Something else',
    },
  ];

  const questions = [...options];

  if (customerType === 'electrician_company/organization') {
    questions.push({
      label: t('blocks:staticForms.replacemenetStationInCpLabel'),
      value: 'Replacement',
    });
  }

  return questions;
};
